import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sweh',
    standalone: false
})
export class SwehPipe implements PipeTransform {
  transform(value: string, isSweh: boolean): string {
    return (isSweh && value === 'FES' ? 'SWEH' : value);
  }
}
